<template>
  <span
    class="w-fit group flex items-center rounded-2xl pl-4 py-1 text-sm bg-primary-50 dark:bg-darkblue-600 text-primary-800 m-1"
  >
    <span class="mr-4 break-words" >{{ this.label }} : {{ this.value }}</span>
  </span>
</template>

<script>
import { ROLES } from '@/config/roles'
import { TIPOS_AUTH } from '@/config/tipos-auth'
import { TIPOS_ESTADO_DESCARGA } from '@/config/tipos-estado-descarga'
import { OPERADORES } from '@/config/operadores'
import { ESTADOS_DIAS_CORTESIA } from '@/config/estados-dias-cortesia'
import { TIPOS_GRUPO } from '@/config/tipos-grupo'
import { TIPOS_CERT } from '@/config/tipos-cert'

import { TIPOS_DISTRIBUIDOR } from '@/config/tipos-distribuidor'
import { TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO } from '@/config/tipos-distribuidor-provisionamiento'

import { TIPOS_IMPORTACION } from '@/config/tipos-importacion'
import { TIPOS_IMPORTACION_ESTADO } from '@/config/tipos-importacion-estado'

import { TIPOS_PRESENTACION_ESTADO } from '@/config/tipos-presentacion-estado'

import { TIPOS_MODULOS } from '@/config/tipos-modulos'

import { TIPOS_FASES_CONFIGURACION } from '@/config/tipos-fases-configuracion'
import { TIPOS_PAQUETES_CONTRATACION } from '@/config/tipos-paquetes-contratacion'

import { TIPOS_AUTENTICACION_API } from '@/config/tipos-autenticacion-api'

import { TIPOS_DILIGENCIAS } from '@/config/tipos-diligencias'
import { TIPOS_DILIGENCIAS_ESTADO } from '@/config/tipos-diligencias-estado'

import { TIPOS_HSM } from '@/config/tipos-hsm'
import { TIPOS_CLIENTE } from '@/config/tipos-cliente'

import { ESTADOS_SUGERENCIAS } from '@/config/estados-sugerencias'

import { TIPOS_MOMENTO_APLICACION_REGLAS_FILTROS } from '@/config/tipos-momento-aplicacion-reglas-filtros'

export default {
  name: 'base-filter-tag-item-searches',
  props: {
    tag: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      roles: ROLES,
      tiposAuth: TIPOS_AUTH,
      tiposEstadoDescarga: TIPOS_ESTADO_DESCARGA,
      operators: OPERADORES,
      estadosDiasCortesia: ESTADOS_DIAS_CORTESIA,
      tiposGrupo: TIPOS_GRUPO,
      tiposDistribuidor: TIPOS_DISTRIBUIDOR,
      tiposProvisionamiento: TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO,
      tiposImportacion: TIPOS_IMPORTACION,
      tiposImportacionEstado: TIPOS_IMPORTACION_ESTADO,
      tiposModulos: TIPOS_MODULOS,
      tiposPresentacionEstado: TIPOS_PRESENTACION_ESTADO,
      tiposFasesConfiguracion: TIPOS_FASES_CONFIGURACION,
      tiposPaquetesContratacion: TIPOS_PAQUETES_CONTRATACION,
      tiposAutenticacion: TIPOS_AUTENTICACION_API,
      tiposHSM: TIPOS_HSM,
      tiposCliente: TIPOS_CLIENTE,
      tiposCert: TIPOS_CERT,
      tiposDiligencias: TIPOS_DILIGENCIAS,
      tiposDiligenciasEstado: TIPOS_DILIGENCIAS_ESTADO,
      estadosSugerencias: ESTADOS_SUGERENCIAS,
      tiposMomentoAplicacionReglas: TIPOS_MOMENTO_APLICACION_REGLAS_FILTROS,
      // types: [],
    }
  },
  mounted: async function () {
    // this.types = await this.$store.getters['app/notificationsTypes']
  },
  methods: {
  },
  computed: {
    label: function () {
      return this.tag[1]
    },
    value: function () {
      // Mixin
      return this.getValueTagFormated(this.tag)
    },
  },
}
</script>

<style lang="scss" scoped></style>
